// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

export default {
  Card: {
    select: 'Selecione',
    titleLinkTooltip: 'Ir para a página',
    collapseCardTooltip: 'Recolher o cartão',
    expandCardTooltip: 'Expandir o cartão'
  },
  CardList: {
    loadMore: 'Carregar mais',
    notFound: 'Nenhum item encontrado.',
    toolbarSelect: 'Selecione',
    viewCards: 'Cartões',
    viewTiles: 'Mosaicos',
    viewList: 'Lista',
    toolbarView: 'Visualizar'
  },
  ClosingConfirmation: {
    confirm: 'Deixar',
    cancel: 'Voltar',
    content: 'Tem certeza de que deseja fechar e sair esta janela? Quaisquer alterações de dados que você tenha feito não serão salvas.'
  },
  Cuttable: {
    showMore: 'Mostrar mais',
    showLess: 'Mostrar menos'
  },
  Dialog: {
    cancelButton: 'Cancelar'
  },
  DrawerProgress: {
    cancelButton: 'Cancelar'
  },
  Dropdown: {
    close: 'Fechar'
  },
  Form: {
    submitButton: 'Salvar',
    applyButton: 'Aplicar',
    cancelButton: 'Cancelar'
  },
  FormField: {
    clear: 'Limpar',
    remove: 'Remover',
    addMore: 'Adicionar mais um'
  },
  FormFieldPassword: {
    improvePassword: 'Para melhorar sua senha:',
    passwordTooShort: 'Use um maior comprimento de senha.',
    lettersLowerCase: 'Utilize no mínimo um caractere minúsculo.',
    lettersUpperCase: 'Utilize no mínimo um caractere maiúsculo.',
    numbers1: 'Utilize no mínimo um número.',
    numbers3: 'Utilize no mínimo três números.',
    specialChar1: 'Use no mínimo um caractere especial (por exemplo: !, @, #, $, %, ^, &, *, ?, _, ~).',
    specialChar2: 'Use no mínimo dois caracteres especiais (por exemplo: !, @, #, $, %, ^, &, *, ?, _, ~).',
    comboUpperAndLower: 'Utilize caracteres maiúsculos e minúsculos.',
    comboLettersAndNumbers: 'Utilize números e caracteres.',
    comboLettersNumbersSpecial: 'Utilize números, caracteres e caracteres especiais.',
    yourPasswordIsStrong: 'Você pode torná-la ainda mais forte aumentando seu comprimento.',
    passwordStrength: 'A força da senha é %%strength%%.',
    strengthVeryStrong: 'MUITO FORTE',
    strengthStrong: 'FORTE',
    strengthVeryWeak: 'MUITO FRACA',
    strengthWeak: 'FRACA',
    strengthMedium: 'MÉDIA',
    hidePassword: 'Ocultar senha',
    showPassword: 'Mostrar senha',
    generateButton: 'Gerar',
    copyButtonHint: 'Copiar senha',
    copySuccessToast: 'A senha foi copiada',
    generateButtonHint: 'Gere uma senha forte'
  },
  InPlaceEdit: {
    editButtonHint: 'Editar valor',
    okButtonHint: 'Salvar alterações',
    cancelButtonHint: 'Descartar as alterações'
  },
  InputFile: {
    browseButton: 'Escolher arquivo...'
  },
  List: {
    totalRows: 'Total de %%totalRows%% itens',
    selectedRows: '%%selectedRows%% de %%totalRows%% itens selecionados',
    all: 'Todos',
    allItemsOnPageSelected: 'Todos os itens na página selecionados',
    allItemsSelected: 'Todos os itens selecionados',
    selectAllItems: 'Selecionar todos os itens',
    selectAllItemsOnPage: 'Selecione todos os itens na página',
    deselectAll: 'Desmarcar'
  },
  ListEmptyView: {
    filteredTitle: 'Não foi possível encontrar nenhum item que corresponda ao filtro',
    emptyTitle: 'Parece que não tem nada aqui',
    filteredDescription: 'Refine sua consulta ou remova alguns dos critérios do filtro e tente novamente.'
  },
  ListOperation: {
    cancelButton: 'Cancelar'
  },
  Pagination: {
    totalShort: 'de %%total%%',
    itemsPerPage: 'Itens por página',
    all: 'Todas',
    total: 'Página %%current%% de %%total%%'
  },
  ProgressDialog: {
    closeButton: 'Fechar',
    cancelButton: 'Cancelar'
  },
  Select: {
    noOptions: 'Nenhima opção',
    placeholder: 'Selecione...'
  },
  SpotPopup: {
    total: '%%current%% de %%total%%'
  },
  Toaster: {
    closeGroup: 'Grupo fechado'
  }
};